import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { businessInfo, services } from "../data/content";

export default function Footer() {
  function openCookieBanner() {
    window.dispatchEvent(new Event("ppc:open-cookie-banner"));
  }

  return (
    <footer className="bg-primary text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company */}
          <div>
            <h3 className="font-heading text-xl font-bold uppercase tracking-tight mb-4">
              Pereira<span className="text-secondary"> Plomberie</span>
            </h3>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Artisan plombier chauffagiste à Meaux (77). Dépannage, installation, entretien et rénovation. Intervention rapide, devis gratuit.
            </p>
            <div className="space-y-2 text-sm">
              <a href={businessInfo.phoneTel} className="flex items-center gap-2 text-secondary hover:text-secondary/80 font-bold" data-testid="footer-phone">
                <Phone size={14} /> {businessInfo.phone}
              </a>
              <a href={businessInfo.emailLink} className="flex items-center gap-2 text-slate-300 hover:text-white" data-testid="footer-email">
                <Mail size={14} /> {businessInfo.email}
              </a>
              <p className="flex items-center gap-2 text-slate-400">
                <MapPin size={14} /> {businessInfo.address.full}
              </p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-semibold uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-2">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="text-sm text-slate-400 hover:text-secondary transition-colors" data-testid={`footer-service-${s.slug}`}>
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-lg font-semibold uppercase tracking-wider mb-4">Navigation</h4>
            <ul className="space-y-2">
              {[
                { label: "Accueil", path: "/" },
                { label: "Zones d'intervention", path: "/zones-intervention" },
                { label: "Avis clients", path: "/avis-clients" },
                { label: "FAQ", path: "/faq" },
                { label: "Contact", path: "/contact" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-sm text-slate-400 hover:text-secondary transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-heading text-lg font-semibold uppercase tracking-wider mb-4">Besoin d'aide ?</h4>
            <p className="text-slate-400 text-sm mb-4">Une urgence plomberie ? Un projet d'installation ? Contactez-nous pour un devis gratuit.</p>
            <Link to="/contact" className="inline-block bg-secondary hover:bg-secondary/90 text-white font-bold uppercase tracking-wider py-3 px-6 rounded-sm text-sm transition-all active:scale-95" data-testid="footer-cta-devis">
              Demander un devis
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-slate-500">
          <p>&copy; {new Date().getFullYear()} {businessInfo.name}. Tous droits réservés.</p>
          <div className="flex flex-col items-center sm:items-end gap-2">
            <div className="flex gap-4">
              <Link to="/mentions-legales" className="hover:text-slate-300">Mentions légales</Link>
              <Link to="/politique-confidentialite" className="hover:text-slate-300">Politique de confidentialité</Link>
              <button type="button" onClick={openCookieBanner} className="hover:text-slate-300">
                Cookies
              </button>
            </div>
            <p>
              Site créé par{" "}
              <a
                href={businessInfo.hosting.website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-white transition-colors"
              >
                {businessInfo.hosting.name}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
